// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_2IGDWYlP","tooltip-inner":"_1P5sBCBn","tooltip-arrow":"zhqgfg5B"};